// AUDITORIA-CLINICA-REDISENO (FASE 1 · columna izquierda) -- índice de
// secciones, sticky. Sólo las secciones CON registro son navegables; las que
// el médico no registró se listan al final, en gris y sin acción (nunca un
// control deshabilitado que parezca roto).
//
// El contador NO dice "2 de 7 revisadas": no hay dónde persistir un checklist
// de verificación (FASE 0 §6), así que se informa el dato que sí existe --
// secciones con registro clínico y cuántas de ellas se corrigieron.

function AtencionIndiceSecciones({ conRegistro, sinRegistro, progreso, seccionActiva, corregidas, onIrASeccion }) {
    const porcentaje = progreso.total > 0 ? Math.round((progreso.conRegistro / progreso.total) * 100) : 0;

    return (
        <div className="ac-panel" data-testid="ac-indice">
            <span className="ac-panel__titulo">Secciones</span>
            <div className="ac-progreso__pista" role="presentation">
                <div className="ac-progreso__barra" style={{ width: `${porcentaje}%` }} />
            </div>
            <span className="ac-progreso__texto" data-testid="ac-progreso-texto">
                {progreso.conRegistro} de {progreso.total} con registro
                {progreso.corregidas > 0
                    ? ` · ${progreso.corregidas} corregida${progreso.corregidas === 1 ? "" : "s"}`
                    : " · sin correcciones"}
            </span>

            <div className="ac-indice">
                {conRegistro.map((seccion) => {
                    const corregida = corregidas.has(seccion.id);
                    const activa = seccionActiva === seccion.id;
                    return (
                        <button
                            type="button"
                            key={seccion.id}
                            className={`ac-indice__item${activa ? " is-activa" : ""}`}
                            onClick={() => onIrASeccion(seccion.id)}
                            data-testid={`ac-indice-${seccion.id}`}
                        >
                            <span className={`ac-indice__punto${corregida ? " is-corregida" : ""}`} />
                            <span className="ac-indice__nombre">{seccion.label}</span>
                            {corregida && <span className="ac-indice__badge">Corregido</span>}
                        </button>
                    );
                })}

                {sinRegistro.length > 0 && (
                    <>
                        <span className="ac-indice__separador" />
                        <span className="ac-panel__titulo">Sin registro</span>
                        {sinRegistro.map((seccion) => (
                            <span key={seccion.id} className="ac-indice__item is-vacia" data-testid={`ac-indice-vacia-${seccion.id}`}>
                                <span className="ac-indice__punto" />
                                <span className="ac-indice__nombre">{seccion.label}</span>
                            </span>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
}

export default AtencionIndiceSecciones;
